module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/logo-blue.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/logo-blue.png
// module id = 482
// module chunks = 0